export interface Variant {
  sku: string;
  label: string;
  priceDelta: number;
  stock: number;
}

export interface Product {
  id: string;
  slug: string;
  name: string;
  brand: string;
  price: number;
  /** Cena regularna, jeśli produkt jest w promocji. */
  listPrice?: number;
  category: string;
  subcategory?: string;
  type?: string;
  emoji: string;
  color: string;
  desc: string;
  variants: Variant[];
  /** Sposób realizacji zamówienia — wpływa na czas dostawy. */
  fulfillment: 'magazyn' | 'dropshipping' | 'na zamówienie';
  rating: number;
  reviews: number;
}

export const CURRENCY = 'PLN';
export const FREE_SHIPPING_FROM = 2000;
export const VAT_RATE = 0.23;

export const PRODUCTS: Product[] = [
  {
    id: 'SKU-1001',
    slug: 'fotel-ergo-one',
    name: 'Fotel ergonomiczny Ergo One',
    brand: 'Nordform',
    price: 1299,
    listPrice: 1499,
    category: 'Meble',
    subcategory: 'Biuro',
    type: 'Fotele',
    emoji: '🪑',
    color: '#4f8cff',
    desc: 'Regulowany zagłówek, oparcie z siatki oddychającej, podłokietniki 4D, podstawa aluminiowa. Pięć lat gwarancji na mechanizm.',
    fulfillment: 'magazyn',
    rating: 4.6,
    reviews: 128,
    variants: [
      { sku: 'SKU-1001-BLK', label: 'Czarny', priceDelta: 0, stock: 12 },
      { sku: 'SKU-1001-GRY', label: 'Szary', priceDelta: 50, stock: 3 },
      { sku: 'SKU-1001-BLU', label: 'Granatowy', priceDelta: 50, stock: 0 },
    ],
  },
  {
    id: 'SKU-1002',
    slug: 'biurko-loft',
    name: 'Biurko podnoszone Loft',
    brand: 'Nordform',
    price: 2190,
    category: 'Meble',
    subcategory: 'Biuro',
    type: 'Biurka',
    emoji: '🗄️',
    color: '#22d3a6',
    desc: 'Elektryczna regulacja wysokości 68–118 cm, blat z dębu olejowanego, pamięć czterech pozycji, udźwig 120 kg.',
    fulfillment: 'na zamówienie',
    rating: 4.8,
    reviews: 64,
    variants: [
      { sku: 'SKU-1002-140', label: '140 × 70 cm', priceDelta: 0, stock: 7 },
      { sku: 'SKU-1002-160', label: '160 × 80 cm', priceDelta: 300, stock: 4 },
    ],
  },
  {
    id: 'SKU-2001',
    slug: 'lampa-arc',
    name: 'Lampa biurkowa Arc',
    brand: 'Lumio',
    price: 349,
    listPrice: 399,
    category: 'Oświetlenie',
    subcategory: 'Lampy biurkowe',
    emoji: '💡',
    color: '#f5a623',
    desc: 'CRI 95, płynna regulacja temperatury barwowej 2700–6500 K, ramię przegubowe, zasilanie USB-C.',
    fulfillment: 'magazyn',
    rating: 4.4,
    reviews: 213,
    variants: [
      { sku: 'SKU-2001-WHT', label: 'Biała', priceDelta: 0, stock: 25 },
      { sku: 'SKU-2001-BLK', label: 'Czarna', priceDelta: 0, stock: 18 },
    ],
  },
  {
    id: 'SKU-2002',
    slug: 'monitor-vision-27',
    name: 'Monitor Vision 27" 4K',
    brand: 'Kolab',
    price: 2499,
    category: 'Elektronika',
    subcategory: 'Monitory',
    emoji: '🖥️',
    color: '#a78bfa',
    desc: 'Matryca IPS, pokrycie 99% sRGB, USB-C z zasilaniem 90 W, wbudowany przełącznik KVM, regulacja wysokości.',
    fulfillment: 'magazyn',
    rating: 4.7,
    reviews: 89,
    variants: [
      { sku: 'SKU-2002-STD', label: 'Podstawa standardowa', priceDelta: 0, stock: 9 },
      { sku: 'SKU-2002-ERG', label: 'Ramię monitorowe', priceDelta: 450, stock: 2 },
    ],
  },
  {
    id: 'SKU-3001',
    slug: 'klawiatura-k75',
    name: 'Klawiatura mechaniczna K75',
    brand: 'Kolab',
    price: 599,
    category: 'Elektronika',
    subcategory: 'Akcesoria',
    emoji: '⌨️',
    color: '#ff5c72',
    desc: 'Gniazda hot-swap, warstwy wygłuszające, układ ISO PL, podświetlenie białe, dołączony kabel oplatany.',
    fulfillment: 'dropshipping',
    rating: 4.5,
    reviews: 156,
    variants: [
      { sku: 'SKU-3001-RED', label: 'Switche liniowe', priceDelta: 0, stock: 30 },
      { sku: 'SKU-3001-BRN', label: 'Switche taktylne', priceDelta: 0, stock: 14 },
    ],
  },
  {
    id: 'SKU-3002',
    slug: 'mata-korkowa',
    name: 'Mata korkowa pod biurko',
    brand: 'Nordform',
    price: 189,
    category: 'Akcesoria',
    subcategory: 'Ergonomia',
    emoji: '🟫',
    color: '#d4a373',
    desc: 'Naturalny korek prasowany, spód antypoślizgowy, wymiary 90 × 60 cm, grubość 6 mm.',
    fulfillment: 'magazyn',
    rating: 4.2,
    reviews: 47,
    variants: [{ sku: 'SKU-3002-STD', label: 'Standard', priceDelta: 0, stock: 40 }],
  },
  {
    id: 'SKU-3003',
    slug: 'podnozek-flow',
    name: 'Podnóżek regulowany Flow',
    brand: 'Nordform',
    price: 249,
    category: 'Akcesoria',
    subcategory: 'Ergonomia',
    emoji: '🦶',
    color: '#7dd3fc',
    desc: 'Regulacja kąta 0–30°, powierzchnia masująca, antypoślizgowe nóżki, tworzywo z recyklingu.',
    fulfillment: 'magazyn',
    rating: 4.1,
    reviews: 31,
    variants: [{ sku: 'SKU-3003-STD', label: 'Standard', priceDelta: 0, stock: 22 }],
  },
  {
    id: 'SKU-2003',
    slug: 'lampa-podlogowa-nord',
    name: 'Lampa podłogowa Nord',
    brand: 'Lumio',
    price: 799,
    category: 'Oświetlenie',
    subcategory: 'Lampy podłogowe',
    emoji: '🕯️',
    color: '#fbbf24',
    desc: 'Ściemnialna, klosz tekstylny, statyw dębowy, sterowanie dotykowe, żarówka LED w zestawie.',
    fulfillment: 'na zamówienie',
    rating: 4.3,
    reviews: 18,
    variants: [
      { sku: 'SKU-2003-OAK', label: 'Dąb naturalny', priceDelta: 0, stock: 6 },
      { sku: 'SKU-2003-BLK', label: 'Dąb bejcowany', priceDelta: 80, stock: 5 },
    ],
  },
];

export const bySlug = (slug: string) => PRODUCTS.find((p) => p.slug === slug);
export const byId = (id: string) => PRODUCTS.find((p) => p.id === id);
export const bySku = (sku: string) => PRODUCTS.find((p) => p.variants.some((v) => v.sku === sku));

export const COUPONS: Record<string, { rate: number; label: string }> = {
  LATO10: { rate: 0.1, label: '−10% na całe zamówienie' },
  MEBLE20: { rate: 0.2, label: '−20% na zamówienie' },
  DARMOWA: { rate: 0, label: 'Darmowa dostawa' },
};

export const SHIPPING_METHODS = [
  { id: 'kurier_24', label: 'Kurier 24h', price: 29, eta: 'jutro' },
  { id: 'paczkomat', label: 'Paczkomat', price: 15, eta: '1–2 dni' },
  { id: 'odbior', label: 'Odbiór osobisty', price: 0, eta: 'dziś, Warszawa' },
];

export const PAYMENT_METHODS = [
  { id: 'blik', label: 'BLIK' },
  { id: 'card', label: 'Karta płatnicza' },
  { id: 'transfer', label: 'Szybki przelew' },
  { id: 'cod', label: 'Za pobraniem' },
];
